import { canShowSketchPropertySection, registerPropertyManagerSection } from '@/core';
import SketchConvertEntitiesPropertySection from '@/components/editor/property-manager/convert-entities/SketchConvertEntitiesPropertySection.vue';

registerPropertyManagerSection({
  id: 'convert-entities',
  title: '转换实体引用',
  order: 17,
  component: SketchConvertEntitiesPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.convertEntitiesState?.canConfirm === false,
  isApplicable: (context) => {
    return canShowSketchPropertySection(
      context,
      context.isSketchActive
        && context.convertEntitiesState?.active === true,
    );
  },
  onConfirm: (context) => {
    context.confirmConvertEntities?.();
  },
  onCancel: (context) => {
    context.cancelConvertEntities?.();
  },
});
